module.exports = __webpack_public_path__ + "img/idea1.60c41d77.png";